import { useContext, useEffect } from 'react';
import { KeyboardShortcut } from '@frameio/shared/commands';
import { AppSheetContext, useDispatchAppState } from '@frameio/shared/contexts';
import { useFeedbackDialogContext } from '@frameio/shared/contexts/ModalContext/ModalContext';
import { MenuButton } from '@frameio/vapor';
import { IconLightbulb } from '@frameio/vapor-icons';
import TEXT from './generated/TEXT/SubmitFeedbackMenuItem';

TEXT.DEFINE({
  /** Button label */
  label: 'Submit Feedback',
});

export const SubmitFeedbackMenuItem = () => {
  const { isFeedbackDialogOpen, openFeedbackDialog, closeFeedbackDialog } =
    useFeedbackDialogContext();
  const dispatch = useDispatchAppState();
  const { setId: setSheetId } = useContext(AppSheetContext);

  useEffect(
    function ensureAppSheetCloses() {
      if (isFeedbackDialogOpen) {
        setSheetId?.(null);
        dispatch({ type: 'CLOSE_MOBILE_NAV' });
      }
    },
    [dispatch, setSheetId, isFeedbackDialogOpen]
  );

  const handleOpenFeedbackDialog = () => openFeedbackDialog('featureRequest');

  return (
    <MenuButton
      aria-expanded={isFeedbackDialogOpen}
      aria-label={TEXT.label}
      iconBefore={<IconLightbulb />}
      onClick={
        isFeedbackDialogOpen ? closeFeedbackDialog : handleOpenFeedbackDialog
      }
    >
      <KeyboardShortcut
        id="global.featureRequest"
        onKeyDown={handleOpenFeedbackDialog}
      />
      {TEXT.label}
    </MenuButton>
  );
};
